import { Label } from "@groot/ui/label";
import { cn } from "@/lib/utils";
import { json } from "@codemirror/lang-json";
import { EditorView } from "@codemirror/view";
import CodeMirror from "@uiw/react-codemirror";
import { useId } from "react";

interface JsonEditorFieldProps {
  id?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  helperText?: string;
  disabled?: boolean;
  height?: string;
  placeholder?: string;
  className?: string;
}

export function JsonEditorField({
  id,
  label,
  value,
  onChange,
  helperText,
  disabled = false,
  height = "240px",
  placeholder = "{}",
  className,
}: JsonEditorFieldProps) {
  const fallbackId = useId();
  const editorId = id ?? fallbackId;

  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={editorId}>{label}</Label>
      <div className={cn("rounded-md border border-input", disabled && "opacity-60")}>
        <CodeMirror
          id={editorId}
          value={value}
          height={height}
          extensions={[json(), EditorView.lineWrapping]}
          onChange={(val) => onChange(val)}
          editable={!disabled}
          placeholder={placeholder}
          basicSetup={{
            lineNumbers: true,
            foldGutter: true,
            highlightActiveLineGutter: true,
            highlightActiveLine: true,
          }}
        />
      </div>
      {helperText ? <p className="text-xs text-muted-foreground">{helperText}</p> : null}
    </div>
  );
}
